export const openOverlay = ({ playlistId, videoDetails, voltaxView }) => {
    const mediaId = videoDetails.payload_id
    console.log(`<MVO API> Open overlay - playlistId: ${playlistId} | mediaId: ${mediaId}`)
    if (voltaxView) {
        voltaxView.openOverlay(playlistId, mediaId)
    }
}
